<div class="library-group-list">
  @for (group of groups; track group) {
    <app-library-group [group]="group"></app-library-group>
  } @empty {
    <div class="library-group-list-empty">
      <img [src]="'/svg/empty-creative.svg' | assetVersion" alt=""/>
      <p class="empty-title">No creatives yet</p>
      <p class="empty-subtitle">Creatives referenced in this chat will show up here.</p>
    </div>
  }
</div>
